import { TDocument } from '../types';

type TOrgLike = { folders: { qm?: string; countries?: string } };

// QM/country-reg docs skip the product axis - their root is the org's QM/countries folder, not a product.
const getDocumentProductId = (doc: TDocument, organization: TOrgLike): string | undefined => {
  const rootFolderId = doc.resolvedPath?.[0]?._id;
  if (!rootFolderId || rootFolderId === organization.folders.qm || rootFolderId === organization.folders.countries)
    return undefined;
  return rootFolderId;
};

export default getDocumentProductId;
